export enum PriceTypesEnum {
    GUESTS = 'guests',
    FREE = 'free',
    PIECE = 'piece',
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Do not change this it matches the back-end data
 */
export enum ProductPricingStrategy {
    FlatFee = 'FLAT_FEE',
    PerGuesttype = 'PER_GUESTTYPE',
    PerHour = 'PER_HOUR',
    PerPiece = 'PER_PIECE'
}

export enum ProductSettingTypesEnum {
    LOOSE = 'looseDrink',
    BUYOUT = 'buyoutDrink',
}

export enum PaymentCategoryEnum {
    PAYMENT_LOCATION = 'PAYMENT_LOCATION',
    PAYMENT_SUPPLIER = 'PAYMENT_SUPPLIER',
    PAYMENT_WISHLIST = 'PAYMENT_WISHLIST',
}

export enum PaymentStatusEnum {
    STATUS_PAID = 'STATUS_PAID',
    STATUS_NOT_PAID = 'STATUS_NOT_PAID',
    STATUS_OVERDUE = 'STATUS_OVERDUE',
    STATUS_ON_CHECK = 'STATUS_ON_CHECK',
    STATUS_CANCELLED = 'STATUS_CANCELLED',
    STATUS_FINAL_PAYMENT = 'STATUS_FINAL_PAYMENT',
}

export enum PaymentMethodEnum {
    NOVA_PAY = 'NOVA_PAY',
    BANK_TRANFER = 'BANK_TRANFER',
}
